import { UserManager, UserManagerSettings, WebStorageStateStore, User } from 'oidc-client';

// https://github.com/joaojosefilho/vuejsOidcClient/blob/master/src/services/SecurityService.js

class AuthService {
  public isAuthenticated: boolean = false;
  private oidcSettings: UserManagerSettings = {
    authority: process.env.VUE_APP_AuthService_authority,
    client_id: "js",
    redirect_uri: process.env.VUE_APP_AuthService_redirect_uri,
    response_type: "code",
    scope: "openid profile portalapi",
    post_logout_redirect_uri: process.env.VUE_APP_AuthService_post_logout_redirect_uri,
    userStore: new WebStorageStateStore({})
  };
  private userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(this.oidcSettings);

    this.userManager.getUser().then(user => {
      if (user) {
        this.isAuthenticated = true;
      } else {
        console.log('[AuthService] Not logged in.');
      }
    });
    this.userManager.events.addUserLoaded(() => {
      // Validate user
      console.log('addUserLoaded');
      this.isAuthenticated = true;
    });
    this.userManager.events.addAccessTokenExpired(() => {
      console.log('[AuthService] Access token expired');
      this.signOut();
    });
  }

  public async getAuthenticated(): Promise<boolean>  {
    return await this.userManager.getUser().then(user => {
      if (user) {
        return true;
      } else {
        console.log('[AuthService] Not logged in.');
        return false;
      }
    });
  }


  public signinWithRedirect(path: string) {
    this.userManager.signinRedirect(path);
  }

  public async getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }
  public async getAccessToken(): Promise<string | void> {
    return await this.getUser().then(
      user => {
        if (user) {
          return user.access_token;
        } else {
          return '';
        }
      },
      err => {
        console.log('[AuthService] Failed to get access token.');
        console.log(err);
      }
    );
  }

  public signOut(): void {
    this.userManager.signoutRedirect().then(resp => {
      console.log('[AuthService] Signed out.');
    })
  }

  public async getVendorId(): Promise<string> {
    return await this.getUser().then(
      user => {
        if (user) {
          return user.profile['vendorId'] as string;
        } else
        {
          return '';
        }
      },
      err => { 
        console.log('[AuthService] Failed to get vendorid claim')
        return '' 
      }
    )
  }
}


export const authService = new AuthService()

